import { Close, ExpandMore, Folder, Save } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Divider, Grid, Icon, IconButton, MenuItem, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { formatoNum } from '../../lib/format';
import municipios_estado from '../../lib/municipios.js';

const ProductosTab = ({ productos, imagenes, editable, setData, handleUpdate }) => {
    const [procesoAbierto, setProcesoAbierto] = useState(null);
    const [productoAbierto, setProductoAbierto] = useState(null);
    const handleOpenProceso = (codigo) => {
        procesoAbierto != codigo ? setProcesoAbierto(codigo) : setProcesoAbierto(null);
    }
    const handleOpenProducto = (codigo) => {
        productoAbierto != codigo ? setProductoAbierto(codigo) : setProductoAbierto(null);
    }

    const [catMunicipios, setCatMunicipios] = useState([]);
    const [municipios, setMunicipios] = useState([[]]);
    const [municipioSeleccionado, setMunicipioSeleccionado] = useState([]);
    const handleMunicipios = (municipio, index) => {
        setMunicipios((prev) => {
            let dup = prev[index].filter((p) => p === municipio);
            if (dup.length === 0) {
                return [...prev.slice(0, index), [...prev[index], municipio], ...prev.slice(index + 1)];
            }
            return prev;
        })
    }

    const removeMunicipio = (indexMunicipio, indexActividad) => {
        setMunicipios((prev) => {
            const updatedMunicipios = [...prev];
            const updatedActividadMunicipios = [...updatedMunicipios[indexActividad]];
            updatedActividadMunicipios.splice(indexMunicipio, 1);
            updatedMunicipios[indexActividad] = updatedActividadMunicipios;
            return updatedMunicipios;
        });
        setMunicipioSeleccionado((muns) => {
            const updatedMunicipioSeleccionado = [...muns];
            updatedMunicipioSeleccionado[indexActividad] = ''; // Set to empty string or handle as needed
            return updatedMunicipioSeleccionado;
        });
    };

    useEffect(() => {
        let categorias = Object.keys(municipios_estado);
        let muns = categorias.map((categoria) => municipios_estado[categoria]);
        let m = [];
        muns.forEach((mun) => {
            m = [...m, ...mun];
        });
        setCatMunicipios(m);

        let prevMunicipios = productos.procesos_produccion.map((proceso) => {
            // por cada actividad/proceso, tomar los municipios y ponerlos en un array ex: ['Gdl', '']
            let municipios = proceso.municipios.map((municipio) => {
                return typeof municipio == 'object' ? municipio.municipio : municipio;
            });
            return municipios;
        });
        setMunicipios(prevMunicipios);

    }, []);

    useEffect(() => {
        if (Array.isArray(municipios) && municipios.length > 0) {
            let prevActividades = [...productos.procesos_produccion];
            let newDatos = prevActividades.map((act, index) => {
                if (Array.isArray(municipios[index]) && municipios[index].length > 0) {
                    act.municipios = municipios[index];
                }
                return act;
            })
            setData({ target: { value: newDatos, name: 'procesos_produccion' } });
        }

    }, [municipios]);

    const addActividad = () => {
        let prev = [...productos.procesos_produccion];
        prev.push({
            numero_productores: '',
            superficie_trabajo: '',
            descripcion: '',
            proceso: '',
            municipios: [],
        });
        setData({ target: { value: prev, name: 'procesos_produccion' } });
        setMunicipios(prev => [...prev, []]);
        setMunicipioSeleccionado(prev => [...prev, '']);
        setProcesoAbierto(productos.procesos_produccion.length);
    }

    const removeAct = (index) => {
        let prev = [...productos.procesos_produccion];
        prev = prev.filter((p, i) => i !== index);
        setData({ target: { value: prev, name: 'procesos_produccion' } });
        setMunicipios((prev) => prev.filter((p, i) => i !== index));
        setMunicipioSeleccionado((prev) => prev.filter((p, i) => i !== index));
        setProcesoAbierto(null);
    }


    const handleChangeAct = (e, index) => {
        setData(e, 'procesos_produccion', index);
    }


    const handleChangeProd = (e, index) => {
        setData(e, 'productos_servicios', index);
    }


    const addCert = () => {
        setData({ target: { value: [...productos.certificados, ''], name: 'certificados' } })
    }

    const removeCert = (index) => {
        let prev = [...productos.certificados];
        let newCerts = prev.filter((c, i) => i != index);
        setData({ target: { value: newCerts, name: 'certificados' } });
    }


    const handleChangeCert = (e, index) => {
        let prev = [...productos.certificados];
        prev[index] = e.target.value;
        setData({ target: { value: prev, name: 'certificados' } });
    }

    const addPresentacion = (index) => {
        let prev = [...productos.productos_servicios];
        prev[index].presentaciones = [...prev[index].presentaciones, ''];
        setData({ target: { value: prev, name: 'productos_servicios' } });
    }

    const removePresentacion = (index, indexPres) => {
        let prev = [...productos.productos_servicios];
        prev[index].presentaciones = prev[index].presentaciones.filter((p, i) => i != indexPres);
        setData({ target: { value: prev, name: 'productos_servicios' } });
    }

    const handleChangePresentacion = (e, index, indexPres) => {
        let prev = [...productos.productos_servicios];
        prev[index].presentaciones[indexPres] = e.target.value;
        setData({ target: { value: prev, name: 'productos_servicios' } });
    }

    const addProd = () => {
        let prev = [...productos.productos_servicios];
        prev.push({
            producto_servicio: '',
            presentaciones: [],
        });
        setData({ target: { value: prev, name: 'productos_servicios' } });
        setProductoAbierto(productos.productos_servicios.length);
    }

    const removeProd = (index) => {
        let prev = [...productos.productos_servicios];
        prev = prev.filter((p, i) => i !== index);
        setData({ target: { value: prev, name: 'productos_servicios' } });
        setProductoAbierto(null);
    }


    const handleInput = (e, seccion, index = null) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result;
                imagen.paso = 'productos_servicios';
                imagen.seccion = seccion;
                imagen.indice = index;
                setData({
                    target: { name: 'imagenes', value: [...imagenes, imagen] }
                }, 0);
            };
            reader.readAsDataURL(imagen);
        }
    };
    const removeImg = (index) => {
        setData({ target: { name: 'imagenes', value: imagenes.filter((e, i) => i != index) } });
    }
    if (productos) {
        return (
            <Box sx={{ m: 2 }}>
                <Box sx={{ mb: 2 }}>
                    <Typography sx={{ my: 2 }} variant="h6">Integración productiva</Typography>
                    {editable ?
                        <Stack directon="column" spacing={1}>
                            <TextField name="socios_directos" type="number" onChange={setData} value={productos.socios_directos} label="Socios integrados y participando en procesos directos de la empresa" />
                            <TextField name="socios_proveedores" type="number" onChange={setData} value={productos.socios_proveedores} label="Socios participando como proveedores para la empresa" />
                            <TextField name="proveedores_externos" type="number" onChange={setData} value={productos.proveedores_externos} label="Proveedores externos de la empresa" />
                        </Stack>
                        :
                        <>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography>Socios integrados y participando en procesos directos de la empresa</Typography>
                                <Typography textAlign="right" fontWeight='bold'>{formatoNum(productos.socios_directos)}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography>Socios participando como proveedores para la empresa</Typography>
                                <Typography textAlign="right" fontWeight='bold'>{formatoNum(productos.socios_proveedores)}</Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography>Proveedores externos de la empresa</Typography>
                                <Typography textAlign="right" fontWeight='bold'>{formatoNum(productos.proveedores_externos)}</Typography>
                            </Box>
                        </>
                    }
                </Box>
                <Divider />
                <Typography sx={{ my: 2 }} variant="h6">Actividades y procesos de producción</Typography>
                <Box sx={{ mb: 2 }}>
                    {productos.procesos_produccion.map((proceso, index) => {
                        return (
                            <Accordion key={proceso.id} expanded={procesoAbierto === index} onChange={() => handleOpenProceso(index)} sx={{ boxShadow: 2, borderRadius: 1, my: 1 }}>
                                <AccordionSummary expandIcon={<ExpandMore />}>
                                    {procesoAbierto !== index &&
                                        <Typography variant='body1' fontWeight='bold'>{proceso.descripcion}</Typography>
                                    }
                                </AccordionSummary>
                                <AccordionDetails>
                                    {editable ?
                                        <Stack direction='column' spacing={1}>
                                            <TextField name="descripcion" onChange={(e) => handleChangeAct(e, index)} value={proceso.descripcion} label="Descripción" />
                                            <TextField name="proceso" onChange={(e) => handleChangeAct(e, index)} value={proceso.proceso} label="Proceso" />
                                            <TextField name="numero_productores" type="number" onChange={(e) => handleChangeAct(e, index)} value={proceso.numero_productores} label="Número de productores" />
                                            <TextField name="superficie_trabajo" type="number" onChange={(e) => handleChangeAct(e, index)} value={proceso.superficie_trabajo} label="Superficie de trabajo (Ha)" />
                                            {/* Municipios */}
                                            <Autocomplete
                                                fullWidth
                                                disableClearable
                                                name="municipio"
                                                options={catMunicipios}
                                                getOptionLabel={(option) => {
                                                    return option ?? ''
                                                }}
                                                value={municipioSeleccionado[index]}
                                                onChange={(e, municipio) => {
                                                    handleMunicipios(municipio, index);
                                                    setMunicipioSeleccionado((muns) => {
                                                        const newArray = [...muns];
                                                        newArray[index] = municipio;
                                                        return newArray;
                                                    });
                                                }}
                                                renderInput={params => (
                                                    <TextField {...params} label="Municipios" />
                                                )}
                                            />
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                                <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                                                    {Object.values(imagenes).map((image, indexImg) => {
                                                        if (image.paso == 'productos_servicios' && image.seccion == 'galeria_actividades_procesos' && image.indice == index) {
                                                            return (
                                                                <Grid
                                                                    item
                                                                    md={4}
                                                                    key={indexImg}
                                                                    sx={{ position: 'relative', border: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center', width: '100%' }}>
                                                                    <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => removeImg(indexImg)}>
                                                                        <Close />
                                                                    </IconButton>
                                                                    <img src={image.url_img ?? image.dataurl} alt={image.name} style={{ objectFit: 'contain' }} width="150px" />
                                                                </Grid>
                                                            )
                                                        }

                                                    }
                                                    )}
                                                    <Grid item xs={12}>
                                                        <Button
                                                            disabled={imagenes.filter((i) => i.paso == 'productos_servicios' && i.seccion == 'galeria_actividades_procesos' && i.indice == index).length > 2}
                                                            component="label"
                                                            variant="contained"
                                                            startIcon={<Folder />}
                                                        >
                                                            Agregar <input name="galeria_actividades_procesos" onInputCapture={(e) => handleInput(e, 'galeria_actividades_procesos', index)} type="file" accept='image/*' hidden />
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            <Box sx={{ my: 4, display: 'flex', justifyContent: 'center' }}>
                                                <Button color="error" variant="contained" onClick={() => removeAct(index)}>Eliminar Actividad</Button>
                                            </Box>
                                        </Stack>
                                        :
                                        <>
                                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                                <Grid item xs={6}>
                                                    <Typography>Descripción: </Typography>
                                                    <Typography sx={{ whiteSpace: 'pre-line' }} variant='body1'>{proceso.descripcion}</Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography>Proceso: </Typography>
                                                    <Typography>{proceso.proceso}</Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography>Municipios:</Typography>
                                                    {/* Municipios */}
                                                    <Typography sx={{ ml: 1 }}>{(proceso.municipios && proceso.municipios.length > 0) && proceso.municipios.map((mun, i) => {
                                                        let res = typeof mun == 'object' ? mun.municipio : mun;
                                                        return i == 0 ? res : `, ${res}`
                                                    })}</Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography>Cantidad de productores</Typography>
                                                    <Typography textAlign='end' sx={{ mr: 6 }}>{formatoNum(proceso.numero_productores)}</Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography>Superficie de trabajo (Ha)</Typography>
                                                    <Typography textAlign='end' sx={{ mr: 6 }}>{proceso.superficie_trabajo}</Typography>
                                                </Grid>
                                            </Grid>
                                            <Typography>Fotogalería de la actividad o proceso</Typography>
                                            <Grid container spacing={2}>
                                                {Object.values(imagenes)
                                                    .map((img, indexImg) => {
                                                        if (img.paso === 'productos_servicios' && index == img.indice && img.seccion == 'galeria_actividades_procesos') {
                                                            return (
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={4}
                                                                    key={indexImg}
                                                                    sx={{ display: 'flex', justifyContent: 'center' }}
                                                                >
                                                                    <img
                                                                        src={img.url_img ?? img.dataurl}
                                                                        width="100%"
                                                                        alt={indexImg}
                                                                        style={{ maxWidth: '300px', objectFit: 'contain' }}
                                                                    />
                                                                </Grid>
                                                            )

                                                        }
                                                    })}

                                            </Grid>
                                        </>
                                    }
                                </AccordionDetails>
                            </Accordion>
                        )
                    })}
                    {/* Si es editable, boton para agregar nueva actividad/proceso */}
                    {editable &&
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Button variant="contained" onClick={addActividad}>Agregar Actividad</Button>
                        </Box>
                    }
                </Box>

                <Divider />

                <Typography sx={{ my: 2 }} variant="h6">Productos y servicos</Typography>
                {productos.productos_servicios.map((producto, index) => {
                    return (
                        <Box sx={{ mb: 2 }}>
                            <Accordion key={producto.id} expanded={productoAbierto === index} onChange={() => handleOpenProducto(index)} sx={{ boxShadow: 2, borderRadius: 1, my: 1 }}>
                                <AccordionSummary expandIcon={<ExpandMore />}>
                                    {productoAbierto !== producto.id &&
                                        <Typography variant='body1' fontWeight='bold'>{producto.producto_servicio}</Typography>
                                    }
                                </AccordionSummary>
                                {
                                    editable ?
                                        <AccordionDetails>
                                            <Stack direction="column">
                                                <TextField label="Descripción" name="producto_servicio" value={producto.producto_servicio} onChange={(e) => handleChangeProd(e, index)} />
                                                <Grid container spacing={1} sx={{ my: 2 }}>
                                                    {producto.presentaciones.map((presentacion, i) => {
                                                        return (
                                                            <Grid item xs={12} lg={4}>
                                                                <TextField InputProps={{
                                                                    endAdornment: <IconButton onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        removePresentacion(index, i);
                                                                    }}><Close /></IconButton>
                                                                }} fullWidth label={`Presentación ${i + 1}`} name={`presentacion${i}`} onChange={(e) => handleChangePresentacion(e, index, i)} value={typeof presentacion == 'object' ? presentacion.presentacion : presentacion} />
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                            </Stack>
                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', my: 2 }}>
                                                <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                                                    {Object.values(imagenes).map((image, indexImg) => {
                                                        if (image.paso == 'productos_servicios' && image.seccion == 'galeria_productos_servicios' && image.indice == index) {
                                                            return (
                                                                <Grid
                                                                    item
                                                                    md={4}
                                                                    key={indexImg}
                                                                    sx={{ position: 'relative', border: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center', width: '100%' }}>
                                                                    <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => removeImg(indexImg)}>
                                                                        <Close />
                                                                    </IconButton>
                                                                    <img src={image.url_img ?? image.dataurl} alt={image.name} style={{ objectFit: 'contain' }} width="150px" />
                                                                </Grid>
                                                            )

                                                        }
                                                    }
                                                    )}
                                                    <Grid item xs={12}>
                                                        <Button
                                                            disabled={imagenes.filter((i) => i.paso == 'productos_servicios' && i.seccion == 'galeria_productos_servicios' && i.indice == index).length > 2}
                                                            component="label"
                                                            variant="contained"
                                                            startIcon={<Folder />}
                                                        >
                                                            Agregar <input name="galeria_productos_servicios" onInputCapture={(e) => handleInput(e, 'galeria_productos_servicios', index)} type="file" accept='image/*' hidden />
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                            {/* Agregar presentacion */}
                                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <Button variant="contained" onClick={() => addPresentacion(index)}>Agregar Presentación</Button>
                                                <Button sx={{ ml: 2 }} color="error" variant="contained" onClick={() => removeProd(index)}>Eliminar Producto/Servicio</Button>
                                            </Box>

                                        </AccordionDetails>
                                        :
                                        // vista
                                        <AccordionDetails>
                                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                                <Grid item xs={6}>

                                                    <Typography>Descripción: </Typography>
                                                    <Typography sx={{ whiteSpace: 'pre-line' }} variant='body1'>{producto.producto_servicio}</Typography>
                                                    {/* Aqui van las presentaciones */}
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography>Presentaciones</Typography>
                                                    {producto.presentaciones.map((presentacion) => {
                                                        return (
                                                            <Box>
                                                                <Typography>{typeof presentacion == 'object' ? presentacion.presentacion : presentacion}</Typography>
                                                            </Box>
                                                        )
                                                    })}
                                                </Grid>
                                            </Grid>

                                            {/* Imagenes */}
                                            <Typography>Fotogalería del producto o servicio</Typography>
                                            <Box sx={{ my: 2 }}>
                                                <Grid container spacing={2}>
                                                    {Object.values(imagenes)
                                                        .filter((i) => i.paso === 'productos_servicios' && index == i.indice && i.seccion == 'galeria_productos_servicios')
                                                        .map((img, index) => {
                                                            return (
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={4}
                                                                    key={index}
                                                                    sx={{ display: 'flex', justifyContent: 'center' }}
                                                                >
                                                                    <img
                                                                        src={img.url_img ?? img.dataurl}
                                                                        width="100%"
                                                                        alt={index}
                                                                        style={{ maxWidth: '300px', objectFit: 'contain' }}
                                                                    />
                                                                </Grid>
                                                            )
                                                        })}

                                                </Grid>
                                            </Box>
                                        </AccordionDetails>
                                }
                            </Accordion>

                        </Box>
                    )
                })}
                {editable &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <Button variant="contained" onClick={addProd}>Agregar Producto/Servicio</Button>
                    </Box>
                }
                <Divider />
                {/* Certificados */}
                <Typography sx={{ my: 2 }} variant="h6">Certificados</Typography>
                {editable ?
                    <Box>
                        <Grid container spacing={2}>
                            {productos.certificados.map((certificado, i) => {
                                return (
                                    <Grid item xs={6} lg={4}>
                                        <TextField
                                            fullWidth
                                            name="certificado"
                                            label={`Certificado ${i + 1}`}
                                            value={typeof certificado == 'object' ? certificado.nombre : certificado}
                                            onChange={(e) => handleChangeCert(e, i)}
                                            InputProps={{ endAdornment: <IconButton onClick={() => removeCert(i)}><Close /></IconButton> }}
                                        />
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Box>
                    :
                    productos.certificados.map((certificado) =>
                        <Typography sx={{ my: 1 }}>{typeof certificado == 'object' ? certificado.nombre : certificado}</Typography>
                    )}
                {editable &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                        <Button variant="contained" onClick={addCert}>Agregar Certificado</Button>
                    </Box>
                }

                {/* Boton para actualizar datos de este tab. (Excepto imagenes, se actualizaran al vuelo) */}
                {editable &&
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate} >Guardar esta sección</Button>
                    </Box>
                }
            </Box>
        )
    }
}

export default ProductosTab
